import { STATUS_COLOR_CLASS, STATUS_SOLID_CLASS } from '@/styles/statusColors';
import type { TeacherSummary } from '../types/teacherSubmission.types';

export const TEACHER_LIST_PAGE_SIZE = 50;

export const UPDATED_FROM_FILTER_KEY = 'updatedFrom';

export const UPDATED_TO_FILTER_KEY = 'updatedTo';

const RECENT_UPDATE_DAYS = 7;

interface TeacherSummaryCardConfig {
  key: keyof TeacherSummary;
  label: string;
}

export const TEACHER_SUMMARY_CARDS: TeacherSummaryCardConfig[] = [
  { key: 'total', label: 'Total' },
  { key: 'active', label: 'Active' },
  { key: 'inactive', label: 'Inactive' },
  {
    key: 'recentlyUpdated',
    label: `Updated last ${RECENT_UPDATE_DAYS} days`,
  },
];

export const PERCENT_SCALE = 100;

export const TEACHER_CARD_CLASS = 'overflow-hidden rounded-xl border bg-card shadow-xs';

export const TEACHER_CATEGORY = ['SALES', 'CONTENT', 'GENERAL', 'BHAIYA_GROUP'] as const;

export const TEACHER_CATEGORY_LABELS: Record<(typeof TEACHER_CATEGORY)[number], string> = {
  SALES: 'Sales',
  CONTENT: 'Content',
  GENERAL: 'General',
  BHAIYA_GROUP: 'Bhaiya Group',
};

export const TEACHER_CATEGORY_BADGE_CLASS: Record<(typeof TEACHER_CATEGORY)[number], string> = {
  SALES: STATUS_COLOR_CLASS.success,
  CONTENT: 'bg-palette-violet/10 text-palette-violet',
  GENERAL: 'bg-palette-blue/10 text-palette-blue',
  BHAIYA_GROUP: STATUS_COLOR_CLASS.warning,
};

export const TEACHER_STATUS = ['active', 'inactive'] as const;

export const TEACHER_STATUS_LABELS: Record<(typeof TEACHER_STATUS)[number], string> = {
  active: 'Active',
  inactive: 'Inactive',
};

export const TEACHER_STATUS_DOT_CLASS: Record<(typeof TEACHER_STATUS)[number], string> = {
  active: STATUS_SOLID_CLASS.success,
  inactive: STATUS_SOLID_CLASS.danger,
};

export const TEACHER_GENDER = ['MALE', 'FEMALE'] as const;

export const TEACHER_GENDER_LABELS: Record<(typeof TEACHER_GENDER)[number], string> = {
  MALE: 'Male',
  FEMALE: 'Female',
};

export const TEACHER_MARITAL_STATUS = ['MARRIED', 'UNMARRIED'] as const;

export const TEACHER_MARITAL_STATUS_LABELS: Record<
  (typeof TEACHER_MARITAL_STATUS)[number],
  string
> = {
  MARRIED: 'Married',
  UNMARRIED: 'Unmarried',
};

export const TEACHER_PRIORITY = ['A', 'B', 'C', 'D'] as const;

export const TEACHING_MEDIUM = ['BANGLA', 'ENGLISH'] as const;

export const TEACHING_MEDIUM_LABELS: Record<(typeof TEACHING_MEDIUM)[number], string> = {
  BANGLA: 'Bangla',
  ENGLISH: 'English',
};
